<body class="bethubs">
  <div class="loginbg">
    <div class="login">
      <div>
        <h3 class="text-center">
          <img alt="admin-logo" src="assets/img/{{env.host.name}}/admin-logo.svg" />
        </h3>
      </div>
      <div>
        <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
          <div class="form-group">
            <label for="username">User Name:</label><input type="text" id="username" autocapitalize="off"
              autocorrect="off" spellcheck="false" class="form-control" placeholder="Enter Username"
              formControlName="username" required="" />
            <!-- <span class="error d-none">Error</span> -->
            <div *ngIf="submitted && f.username.errors" class="invalid-feedback">
              <div *ngIf="f.username.errors.required">The User Name field is required</div>
            </div>
          </div>
          <div class="form-group">
            <label for="pwd">Password:</label><input [type]="passwordTextType ? 'text' : 'password'" id="pwd" class="form-control"
              placeholder="Enter password" formControlName="password" placeholder="Enter Password" required="" />
            <span class="Passcode-visible" (click)="togglePasswordFieldTextType()"><i class="fa " [ngClass]="{'fa-eye': !passwordTextType, 'fa-eye-slash': passwordTextType }" aria-hidden="true"></i></span>
            <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
              <div *ngIf="f.password.errors.required">The Password field is required</div>
            </div>
          </div>
          <div>
            <button type="submit" [disabled]="loginForm.invalid || isLoad" class="text-center login-bt">
              LOGIN <i *ngIf="isLoad" class="fa fa-spinner fa-spin"></i>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</body>